/// <reference path="../ProjectFinder2/ProjectFinderHomeLM.ts" />
import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import { EvBookingEditor, VAMtypes, EvBookingView, RoomBlockingForm } from "../_loadingHelpers/VAM";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';

class EvBookingAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
    //templateString = template; // Standard verwenden...

    buttonClickTimeout: number = null;

    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    //private tableFormatter(cell: StaticTable.StaticTableCell<Types.EvBooking>) {
    //    let node = cell.contentnode;
    //    let entity = cell.entity;
    //    let colName = cell.name;
    //    let value = cell.value;
    //    switch (colName) {
    //        case "date":
    //            let dateFrom = entity.date_start;
    //            let dateTo = entity.date_end;

    //            node.innerHTML = this.dateToString(entity.date_start, "dd.MM.yyyy HH:mm") + " - " + this.dateToString(entity.date_end, "dd.MM.yyyy HH:mm");
    //            break;
    //        default:
    //            node.innerHTML = value;
    //    }
    //}

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
        if (this.hasFeature("EvBooking/RoomBlocking")) {
            if (this.hasUserRole(["EvBooking_Create"/*, explizit mal nur Create "EvBooking_Edit"*/])) {
                this.createContextButton({
                    label: this.translations["BookingEditor__RoomBlocking"],
                    callback: lang.hitch(this, this._onClick_CreateRoomBlockingBtn),
                    placement: "top",
                    iconClass: "fas fa-calendar-times",
                    permanent: false
                });

                this.createContextButton({
                    label: this.translations["BookingEditor__RoomBlocking"],
                    callback: lang.hitch(this, this._onClick_CreateRoomBlockingBtn),
                    placement: "bottombar",
                    iconClass: "fas fa-calendar-times",
                    permanent: false
                });
            }
        }
    }

    private _onClick_CreateRoomBlockingBtn(): void {
        console.log(this);
        let form = new RoomBlockingForm();

        let startDate = new Date();
        let selectedDate = this.agendaView.datePicker.getValue();
        if (selectedDate != null) {
            startDate = selectedDate;
        }

        form.setup(this.translations["RoomBlockingForm__Title"], {
            dateStart: startDate,
            dateEnd: startDate,
            isFulltime: false
        });

        form.startup();

        let dlg = new GenericDialog();

        dlg.show(form,
            this.translations["BookingEditor__RoomBlocking"],
            null, null,
            "okcancel",
            lang.hitch(this, this._onRoomBLockingDlgResult, form, dlg));

        dlg._setOkBtnAttr(true, false);

        dlg.keepOpen = true;

        form.on("result", lang.hitch(dlg, "_setOkBtnAttr", true)); // erster Parameter: anzeigen ja/nein, zweiter: enable Ja/nein

        dlg.show()
    }

    private _onRoomBLockingDlgResult(roomBLockingForm: MdsLax<InstanceType<typeof RoomBlockingForm>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: number) {
        if (result <= 0) {
            dlg.close(-1, true);
            return;
        }

        let data: VAMtypes.RoomBlockingFormData = roomBLockingForm.getData();

        console.log("_onCloneDlgResult", data);
        dlg.disableAllButtons(true);
        this.StandbyStart(dlg.contentContainer);

        this.RequestManager.post(
            window.appRoot + "EvBookingEditor/CreateRoomBlocking",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onCreateRoomBlockingResponse, dlg, roomBLockingForm),
            lang.hitch(this, this._onCreateRoomBlockingError, dlg)
        );
    }

    private _onCreateRoomBlockingResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, roomBlockingForm: MdsLax<InstanceType<typeof RoomBlockingForm>>, response: VAMtypes.RoomBlockingFormResponse) {
        this.StandbyStop();

        if (response.result == "success") {
            dlg.close(1, true);
            this.loadData();
        }

        else {
            dlg.disableAllButtons(false);
        }
    }

    private _onCreateRoomBlockingError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        alert("CreateRoomBlocking: " + error.Message);
        console.error(error.Message);

        this.StandbyStop();
    }

    openDetailView(row: StaticTable.StaticTableRow<VAMtypes.EvBookingEditorEntity>, rowGroup: StaticTable.StaticTableRowGroup<VAMtypes.EvBookingEditorEntity>) {

        let entity = rowGroup.entity;

        let editor = new EvBookingView();
        editor.setup(entity.ID, entity.ev_booking_name);



    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setupAgendaView(
            "EventFinder/GetAgendaFilterOptions",
            "EventFinder/GetAgendaEventList",
            lang.hitch(this, this.openDetailView),
            null, // Standard-Formatter
            null
        );

        this.setTitles("EvBooking_AgendaMainTitle");

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    /**
    * Hook funktion fuer evisio, siehe EvisioChat.ts
    * @param appointmentData
    */
    public async evisioHook_jumpToAppointment(appointmentData: { ID: string, displayName: string, start_date: string, end_date: string, activityStatus_code: string, activityStatus_id: string, venue_code: string, venue_id: string, }) {
        //FIXME - filter panel zuruecksetzen, was das filter panel gar nicht kann :(
        let date = new Date(appointmentData.start_date)
        date.setHours(0, 0, 0, 0);
        this.agendaView.datePicker.setValue(date);
        this.agendaView.datePicker.emit("pageChange", date);
        this.agendaView.datePicker.emit("change", date);

        await new Promise(
            (resolve, reject) =>{
                this.agendaView.resultTable.on("tableDrawn", ()=>{
                    resolve(true);
                });
            }
        );

        let myRow = this.agendaView.resultTable.getRowGroupByKeyValue(appointmentData.ID, "ID");
        if ((typeof myRow == 'undefined') || (myRow == null)){
            this.showToast(this.translate("Evisio_jumpInAgenda_nothingToHighlight"), "far fa-eye-slash");
            console.error("(evisio_action jump in agenda) can't find appointment", appointmentData, myRow, this.agendaView.resultTable);
            return;
        }
        if (myRow.rows.length > 0){
            let targetNode = myRow.rows[0].node;
            targetNode.classList.remove("lessQuickHighlightBg");
            targetNode.classList.add("lessQuickHighlightBg");
            targetNode.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }else{
            this.showToast(this.translate("Evisio_jumpInAgenda_nothingToHighlight"), "far fa-eye-slash");
        }
    }
}

export default mdsWidget(EvBookingAgenda);
